import React from 'react';
import isServer from 'commons/isServer';
import { createPortal } from 'react-dom';

import withBrowserOnly from 'components/hoc/withBrowserOnly';
import Login from './login';
import SignUp from './signup';
import GiftCard from './GiftCard';
import BagSaved from './BagSaved';
import PasswordReset from './PasswordReset';
import ForgotPassword from './forgotPassword';
import TradeQuotesBanner from './TradeQuotesBanner';
import LivestreamNotification from './LivestreamNotification';
import UserOrdersProtectionPlanBanner from './UserOrdersProtectionPlan';
import UserOrdersSubmitReviewPhotoBanner from './UserOrdersSubmitReviewPhoto';
import FabricFavoritedBanner from './FabricFavoritedBanner';
import { useNotificationState } from './utils';

const sidebarModalRootElement = !isServer()
  ? document.getElementById('SidebarModal-root')
  : null;

const NotificationBanner = () => {
  const { type, props } = useNotificationState();

  if (isServer()) {
    return null;
  }

  return createPortal(
    <>
      {type === 'login' && <Login {...props} />}
      {type === 'signup' && <SignUp {...props} />}
      {type === 'forgotPassword' && <ForgotPassword {...props} />}
      {type === 'BagSaved' && <BagSaved {...props} />}
      {type === 'GiftCard' && <GiftCard {...props} />}
      {type === 'PasswordReset' && <PasswordReset {...props} />}
      {type === 'TradeQuotesBanner' && <TradeQuotesBanner {...props} />}
      {type === 'UserOrdersProtectionPlan' && (
        <UserOrdersProtectionPlanBanner {...props} />
      )}
      {type === 'UserOrdersSubmitReviewPhoto' && (
        <UserOrdersSubmitReviewPhotoBanner {...props} />
      )}
      {type === 'LivestreamNotification' && (
        <LivestreamNotification {...props} />
      )}
      {type === 'FabricFavoritedBanner' && <FabricFavoritedBanner {...props} />}
    </>,
    sidebarModalRootElement
  );
};

export default withBrowserOnly(NotificationBanner);
